var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning01New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.0541 18.6668",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.8604 1.00006L1.43828 9.9066C1.14761 10.2554 1.00227 10.4298 1.00005 10.5771C0.998117 10.7052 1.05518 10.827 1.15478 10.9075C1.26936 11.0001 1.49638 11.0001 1.95043 11.0001H8.02707L7.19373 17.6667L14.6159 8.76018C14.9065 8.41137 15.0519 8.23697 15.0541 8.08967C15.056 7.96162 14.999 7.8398 14.8994 7.75931C14.7848 7.66672 14.5578 7.66672 14.1037 7.66672H8.02707L8.8604 1.00006Z",
    stroke: "var(--stroke-0, black)",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning01New);
export default __webpack_public_path__ + "static/media/lightning-01-new.66ef013ee7d3d37c52aa2b154eea8ff6.svg";
export { ForwardRef as ReactComponent };